import React, { useState } from "react";
// import axios from "axios";

export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setDone(null);

    try {
      // const res = await axios.post("https://ecl-cms-5d0d78c9e9b5.herokuapp.com/api/contact-messages", {
      //   data: {
      //     name: form.name,
      //     email: form.email,
      //     company: form.company,
      //     message: form.message,
      //   },
      // });
      // console.log("Message sent:", res.data);

      const res = await fetch("/.netlify/functions/send-inquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          company: form.company,
          message: form.message,
        }),
      });

      if (!res.ok) throw new Error("Failed to send");

      setDone("success");
      setForm({ name: "", email: "", company: "", message: "" });
    } catch (err) {
      console.error("Error sending message:", err);
      setDone("error");
    }

    setLoading(false);
  };

  return (
    <section className="text-center">
      <div className="container" style={{marginBottom:120}}>
        <div className="mb-2">
          <h2 className="fw-bold display-5 section-text-light">Contact us</h2>
        </div>

        <p className="lead">Ready to transform your business? Let’s talk.</p>

        <form className="contact-form text-start" onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              name="name"
              type="text"
              className="form-control"
              value={form.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              name="email"
              type="email"
              className="form-control"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Company</label>
            <input
              name="company"
              type="text"
              className="form-control"
              value={form.company}
              onChange={handleChange}
              placeholder="Enter your company name"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Message</label>
            <textarea
              name="message"
              rows="4"
              className="form-control"
              value={form.message}
              onChange={handleChange}
              placeholder="Write your message"
              required
            />
          </div>

          <button type="submit" className="btn btn-send w-100" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>

          {done === "success" && (
            <div className="mt-3 text-success">Message sent successfully!</div>
          )}

          {done === "error" && (
            <div className="mt-3 text-danger">Failed to send message.</div>
          )}
        </form>
      </div>
    </section>
  );
}
